import { useState } from "react";
import {
    ChevronDown
} from "lucide-react";

import MediaSidebarItem
from "./MediaSidebarItem";

export default function MediaSidebarSection({

    title,
    icon,
    rows = [],

    selectedList,

    onSelect,

    onMenu

}) {

    const [

        open,

        setOpen

    ] = useState(true);

    if (!rows.length) {

        return null;

    }

    return (

        <div className="sidebar-section-wrapper">

            <div

                className="sidebar-section"

                onClick={() =>

                    setOpen(

                        previous => !previous

                    )

                }

            >

                <div className="sidebar-section-left">

                    <ChevronDown

                        size={15}

                        className={

                            open

                                ? "sidebar-chevron open"

                                : "sidebar-chevron"

                        }

                    />

                    <span className="sidebar-section-icon">

                        {icon}

                    </span>

                    <span className="sidebar-section-title">

                        {title}

                    </span>

                </div>

                <span className="sidebar-section-count">

                    {rows.length}

                </span>

            </div>

            {

                open &&

                rows.map(

                    list => (

                        <MediaSidebarItem

                            key={list.id}

                            list={list}

                            active={

                                selectedList === list.id

                            }

                            onClick={() =>

                                onSelect?.(

                                    list.id

                                )

                            }

                            onMenu={onMenu}

                        />

                    )

                )

            }

<style>{`

.sidebar-section-wrapper{

    margin-top:10px;

}

.sidebar-section{

    display:flex;

    justify-content:space-between;

    align-items:center;

    padding:8px 18px;

    margin-bottom:6px;

    cursor:pointer;

    user-select:none;

}

.sidebar-section:hover{

    background:#F8FAFC;

}

.sidebar-section-left{

    display:flex;

    align-items:center;

    gap:8px;

}

.sidebar-chevron{

    color:#94A3B8;

    transition:transform .2s ease;

}

.sidebar-chevron.open{

    transform:rotate(0deg);

}

.sidebar-chevron{

    transform:rotate(-90deg);

}

.sidebar-section-icon{

    display:flex;

    align-items:center;

    color:#475569;

}

.sidebar-section-title{

    font-size:13px;

    font-weight:700;

    color:#475569;

    text-transform:uppercase;

    letter-spacing:.08em;

}

.sidebar-section-count{

    min-width:24px;

    height:22px;

    padding:0 8px;

    border-radius:999px;

    background:#F1F5F9;

    color:#64748B;

    display:flex;

    align-items:center;

    justify-content:center;

    font-size:11px;

    font-weight:700;

}

`}</style>

        </div>

    );

}